// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileNav_wrapper__iAqEP","long":"MobileNav_long__3DJxP","item":"MobileNav_item__x5J35","image":"MobileNav_image__HmF2H","image-active":"MobileNav_image-active__bSnEI"};